<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" ref="anyName" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">
                            <div class="card">
                                <div class="card-header">
                                    <h4  v-if="!this.form.AwardID" class="card-title">Add Award</h4>
                                    <h4  v-if="this.form.AwardID" class="card-title">Update Award</h4>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6">
                                            <!-- <h4 class="text-center">Member</h4> -->
                                            <b-form-group label="First Name" label-for="FirstName">
                                                <b-form-input type="text" id="FirstName" name="firstName"
                                                    autocomplete="firstName" placeholder="First Name"
                                                    v-model="$v.form.AwardFirstName.$model"
                                                    :state="$v.form.AwardFirstName.$dirty ? !$v.form.AwardFirstName.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <!-- <h4 class="text-center">Practice</h4> -->
                                            <b-form-group label="Last Name" label-for="lastName">
                                                <b-form-input type="text" id="lastName" name="lastName"
                                                    autocomplete="lastName" placeholder="Last Name"
                                                    v-model="$v.form.AwardLastName.$model"
                                                    :state="$v.form.AwardLastName.$dirty ? !$v.form.AwardLastName.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="Status" label-for="Status">
                                                <b-form-select v-model="form.Status" :options="StatusOptions" class="mb-3"
                                                    value-field="item" text-field="name" disabled-field="notEnabled">
                                                </b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="Year" label-for="Year">
                                                <b-form-input type="text" id="Year" name="Year" autocomplete="Year"
                                                    placeholder="Year" v-model="$v.form.Year.$model"
                                                    :state="$v.form.Year.$dirty ? !$v.form.Year.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6"></div>
                                        <div class="col-md-6 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span v-if="!this.form.AwardID">Submit</span>
                                                <span v-if="this.form.AwardID">Update</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <!--                                </form>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";
import moment from 'moment'


export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            StatusOptions: [
                { item: 'CA', name: 'CA' },
                { item: 'DC', name: 'DC' },
            ],
            form: {
                AwardID: '',
                AwardFirstName: '',
                AwardLastName: '',
                Year: '',
                Status: 'CA',
            },
            isDisabled: false,
            readonly: true,
        };
    },
    validations: {
        form: {
            AwardFirstName: {
                required,
            },
            AwardLastName: {
                required,
            },
            Year: {
                required,
            },
        }
    },
    mounted() {
        if (this.form.AwardID && this.form.AwardID !== undefined) {
            this.readonly = true;
        } else {
            this.readonly = false;
        }
        this.editMember();
    },
    methods: {
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isDisabled = true;
            API.addUpdateAward(this.form,
                data => {
                    this.isDisabled = false;
                    if (!this.form.AwardID) {
                        if (data.status === 410) {
                            this.$showNotification(data)
                        } else {
                            this.$showNotification({message:'Award added Successfully'},"success")
                            this.submitForm();
                        }
                    } else {
                        if (data.status === 200) {
                            this.$showNotification({message:'Award added Successfully'},"success")
                            this.submitForm();
                            this.$router.push({ name: 'ViewAwards' });
                        } else {
                            this.$showNotification({message:'Please try again.'},"error")
                        }
                    }
                },
                err => {
                    this.isDisabled = false;
                    console.log(err);
                    this.$showNotification({message:"Failed system error"},"error")
                }
            )
        },
        editMember() {
            if (this.$route.params.user) {
                this.form = this.$route.params.user;
            }
        },
        submitForm() {
            this.$refs.anyName.reset();
        },
    }, computed: {},
}
</script>
